import { Stack, Skeleton } from '@mui/material';

export function TransportationTableSkeleton() {
  return (
    <Stack spacing={0.5}>
      <Skeleton variant="rectangular" height={56.5} sx={{ mb: 2 }} />
      {Array(2)
        .fill('1')
        .map((_, i) => (
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{ pb: 2 }}
            key={i}
          >
            <Stack sx={{ flex: 1 }}>
              <Skeleton
                variant="rectangular"
                height={16}
                width={100}
                sx={{ mb: 1 }}
              />
              <Skeleton
                variant="rectangular"
                height={16}
                width={140}
                sx={{ mb: 1 }}
              />
            </Stack>
            <Stack sx={{ flex: 1 }}>
              <Skeleton
                variant="rectangular"
                height={16}
                width={70}
                sx={{ mb: 1 }}
              />
              <Skeleton
                variant="rectangular"
                height={16}
                width={150}
                sx={{ mb: 1 }}
              />
              <Skeleton variant="rectangular" height={16} width={30} />
            </Stack>
            <Stack sx={{ flex: 1 }}>
              <Skeleton
                variant="rectangular"
                height={16}
                width={70}
                sx={{ mb: 1 }}
              />
              <Skeleton
                variant="rectangular"
                height={16}
                width={150}
                sx={{ mb: 1 }}
              />
              <Skeleton variant="rectangular" height={16} width={30} />
            </Stack>
            <Skeleton variant="rectangular" height={16} width={150} />
          </Stack>
        ))}
    </Stack>
  );
}
